import angular from 'angular';
import zebraService from '../../services/zebra.service.js';

export default angular.module('components.ec', [])
    .component('ecList', {
        template: require('./ecList.pug')(),
        controller: ['$state', 'ZebraService', 'ECConfig', function($state, ZebraService, ECConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.catalogid = ECConfig.catalogid;
                ctrl.facetsList= ECConfig.facetsList;
                ctrl.rsnList= ECConfig.rsnList;
                ctrl.attributesList= ECConfig.attributesList;
                ctrl.sortKeysList= ECConfig.sortKeysList;
                ctrl.materialsList= ECConfig.materialsList;

                ctrl.rsnspec  = ctrl.rsnList[0];

                load();
            };

            ////////
            
            function load() {
                var qs  = {
                    id: ctrl.catalogid,
                    operation: 'search',
                    query: 'cql.allRecords=1',
                    recordSchema: ctrl.rsnspec.schema,
                    maximumRecords: 0,
                    facetsEnable: 0,
                    rsnEnable: 1,
                    extraRequestData: ctrl.rsnspec.query 
                };

                console.log('load RSN', ctrl.rsnspec);

                ZebraService.get(qs).$promise.then(function(response) {
                    ctrl.response = response; 
                }, function(err) {
                    console.log(err.message || err);
                });
            }
        }]
    })
    .component('ec', {
        template: require('./ec.pug')(),
        controller: ['$state', 'ECConfig', function($state, ECConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.catalogid = ECConfig.catalogid;
                ctrl.facetsList= ECConfig.facetsList;
                ctrl.rsnList= ECConfig.rsnList;
                ctrl.attributesList= ECConfig.attributesList;
                ctrl.sortKeysList= ECConfig.sortKeysList;
                ctrl.materialsList= ECConfig.materialsList;
            };
        }]
    })
    .component('ecAdvanced', {
        template: require('./ecAdvanced.pug')(),
        controller: [ 'ECConfig', function(ECConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.catalogid = ECConfig.catalogid;
                ctrl.facetsList= ECConfig.facetsList;
                ctrl.attributesList= ECConfig.attributesList;
                ctrl.sortKeysList= ECConfig.sortKeysList;
                ctrl.materialsList= ECConfig.materialsList;
            };
        }]
    })
    .component('ecRelatedInstances', {
        bindings: {
            id: '<'
        },
        template: require('./ecRelatedInstances.pug')(),
        controller: ['ECConfig', function(ECConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.catalogid = ECConfig.catalogid;
                ctrl.facetsList = ECConfig.facetsList;
                ctrl.rsnList = ECConfig.rsnList;
            };
        }]
    })
    .component('ecRsn', {
        bindings: {
            rsnspec: '<',
            querystr: '<',
            catalogid: '@',
            onSelect: '&'
        },
        template: require('./ecRsn.pug')(),
        controller: ['ECConfig', 'ZebraService', function(ECConfig, ZebraService) {
            var ctrl = this;

            ctrl.$onInit = function() {
                console.log('ecrsn:oninit()');
                if (0) {
                    load();
                }
            };

            ctrl.$onChanges = function(changes) {
                console.log('ecrsn:onchanges()');
                if (changes) {
                    if (changes.querystr) {
                        ctrl.querystr = changes.querystr.currentValue;
                        load();
                    }
                }
            };

            ctrl.selectItem = function(item) {
                console.log('selectItem():', item);
                item.rsnspec = ctrl.rsnspec;
                console.log('selectItem(): updated', item);
                ctrl.onSelect({item: item});
            };

            ctrl.isActive = function(cql, index, item) {
                var apt = index + '="' + item.term + '"';
                if (cql) { 
                    return cql.includes(apt);
                } else {
                    return false;
                }
            };

            ////////
            
            function load() {
                console.log('load()');
                var qs  = {
                    id: ctrl.catalogid,
                    operation: 'search',
                    query: ctrl.querystr,
                    recordSchema: ctrl.rsnspec.schema,
                    maximumRecords: 1,
                    facetsEnable: 0,
                    rsnEnable: 1,
                    extraRequestData: ctrl.rsnspec.query 
                };

                console.log('load ec RSN', ctrl.rsnspec);

                ZebraService.get(qs).$promise.then(function(response) {
                    ctrl.response = response; 
                }, function(err) {
                    console.log(err.message || err);
                });
            }
        }]
    })
    .component('ecRsnItem', {
        bindings: {
            active: '@',
            item: '<',
            onSelect: '&',
            templ: '@'
        },
        template: require('./ecRsnItem.pug')(),
        controller: function() {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.item) {
                        ctrl.item = changes.item.currentValue;
                    }
                }
            };

            ctrl.select = function() {
                ctrl.onSelect({item: ctrl.item});
            };
        }
    })
    .value('ECConfig', {
        catalogid: 6,
        collectionsList: [
            {value: '',  name: 'Все коллекции'},
            {value: 'a', name: 'Авторефераты диссертаций'},
            {value: 'b', name: 'Известия ТПУ'},
            {value: 'c', name: 'Томский политехник'},
            {value: 'd', name: 'Вестник науки Сибири'},
            {value: 'e', name: 'Journal of Economics and Social Sciences'},
            {value: 'f', name: 'Материалы конференций'},
            {value: 'g', name: 'Монографии'},
            {value: 'h', name: 'Учебные материалы'},
            {value: 'i', name: 'Курсы Moodle'},
            {value: 'j', name: 'Словари. Справочники. Энциклопедии'},
            {value: 'k', name: 'Патенты'},
            {value: 'm', name: 'Другие ресурсы'}
        ],
        facetsList: [
            {name: __("Author"), index: 'dc.creator', schema: 'zebra::facet::author:p:10'},
            {name: __("Subject heading"), index: 'dc.subject', schema: 'zebra::facet::subject-heading:p:10'},
            {name: __("Publisher"), index:'dc.publisher', schema: 'zebra::facet::publisher:p:10'},
            {name: __("Publication date"), index: 'dc.date', schema: 'zebra::facet::date-of-publication:w:10'},
        ],
        rsnList: [
            {name: __("eHolding collection"),  index: 'cuba.project_tpu_987m', query: 'cuba.project_tpu_987m_Facet=z', schema: 'marcxml'}
        ],
        attributesList: [
            {name: __('Title'), value: 'dc.title'},
            {name: __('Author'), value: 'dc.creator'},
            {name: __('Discipline'), value: 'dc.subject'},
            {name: __('ISBN'), value: 'bath.isbn'},
            {name: __('ISSN'), value: 'bath.issn'},
            {name: __('Year of publication'), value: 'dc.date'},
            {name: __('Geographic location'), value: 'cuba.placePublication'},
            {name: __('Publisher'), value: 'dc.publisher'},
            {name: __('All fields'), value: 'cql.serverChoice'},
            {name: __('Universal Decimal Classification'), value: 'cuba.classificationUDC'},
            {name: __('Library-Bibliographical Classification'), value: 'cuba.classificationLocal'},
            {name: __('OKSVNK Classification'), value: 'cuba.classificationLocal'},
            {name: __('Record insertion date'), value: 'cuba.dateAddedToDB'},
            {name: __('Record identifier'), value: 'rec.id'},
            {name: __('All records?'), value: 'cql.allRecords'},
            {name: __('Exhibition name'), value: 'cql.cuba.exhibition'},
            {name: __('Exhibition identifier'), value: 'cql.cuba.exhibitionCode'},
            {name: __('Discipline name'), value: 'cql.cuba.discipline'}
        ],
        sortKeysList: [
            {name: __('Relevant'), value:''},
            {name: __('Publication date (new)'), value:'cql.sortByDateDescending=0'},
            {name: __('Publication date (old)'), value:'cql.sortByDateAscending=0'},
            {name: __('Author (A-Z)'), value:'cql.sortByAuthorAscending=0', glyphicon: 'glyphicon glyphicon-sort-by-alphabe'},
            {name: __('Author (Z-A)'), value:'cql.sortByAuthorDescending=0', grlyphicon: 'glyphicon glyphicon-sort-by-alphabet-alt'},
            {name: __('Record key (ascending)'), value:'cql.sortByLocalNumberAscending=0'},
            {name: __('Record key (descending)'), value:'cql.sortByLocalNumberDescending=0'},
        ],
        materialsList: [
            {name:__("All content types"), value:""},
            {name:"Книги", value:"(cuba.bibLevel=m and (cuba.recordType=a or cuba.recordType=b))"},
            {name:"Журналы (номера, тома, выпуски)", value:"(cuba.bibLevel=s and cuba.recordLinking=2)"},
            {name:"Статьи", value:"cuba.bibLevel=a"},
            {name:"Электронные ресурсы", value:"cuba.recordType=l"},
            {name:"Диссертации, рефераты", value:"(dc.format=m or dc.format=d)"},
            {name:"Патенты", value:"(cuba.bibLevel=m and dc.format=k)"},
            {name:"Словари", value:"dc.format=e"},
            {name:"Справочники", value:"dc.format=g"},
            {name:"Стандарты", value:"(cuba.bibLevel=m and dc.format=l)"},
            {name:"Учебники", value:"dc.format=j"},
            {name:"Энциклопедии", value:"dc.format=f"}
        ]
    })
    .filter('getCollectionName', ['ECConfig', function(ECConfig) {
        console.log('getCollectionName()');
        return function(input) {
            var ctrl = this;
            for (var i in ECConfig.collectionsList) {
                if (ECConfig.collectionsList[i].value === input) {
                    return ECConfig.collectionsList[i].name;
                }
            }
            return null;
        }
    }])
    .name; 
